import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import moment from 'moment';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import YearPicker from '@comm/YearPicker';
import CompanySearch from '@comm/companySearch';
import { BackBtn } from '@comm/BackBtn';
import { queryOrgCompanyList } from '@api/core/org';
import { queryBonusStaticComMonth } from '@api/hr/bonus';

const FormItem = Form.Item;
class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delFiles: [],
    };
  }

  componentDidMount() {
    this.getOrgCompanyList();
  }

  getOrgCompanyList = () => {
    queryOrgCompanyList().then(res => {});
  };

  getPrice = params => {
    const values = { ...this.props.form.getFieldsValue(), ...params };
    queryBonusStaticComMonth({
      year: values.year,
      companyUuid: values.companyUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.form.setFieldsValue({
          price: res.data.netPay,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const dataItem = this.props.data;
    const { handSubmit } = this.props;
    const params = {
      ...dataItem,
      ...this.props.form.getFieldsValue(),
    };
    const { date } = params;
    if (date) {
      params.year = moment(date).format('YYYY');
    }
    delete params.date;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      company: option.props.children,
    });
    this.getPrice({ companyUuid: value });
  };

  handleYearChange = value => {
    this.getPrice({ year: value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isSubmitting } = this.props;
    const dataItem = this.props.data;
    getFieldDecorator('company', { initialValue: dataItem.company });
    getFieldDecorator('typeName');
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            htmlType="submit"
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {dataItem.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="发放年度" {...ItemLayout}>
                {getFieldDecorator('year', {
                  initialValue: dataItem.year,
                })(<YearPicker defaultValue={dataItem.year} onChange={this.handleYearChange} />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="发放公司" {...ItemLayout}>
                {getFieldDecorator('companyUuid', {
                  rules: [{ required: true, message: '请选择发放公司' }],
                  initialValue: dataItem.companyUuid,
                })(
                  <CompanySearch
                    companyName={dataItem.company}
                    companyUuid={dataItem.companyUuid}
                    onChange={this.handleCompanyChange}
                    {...this.props}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="年终奖金额" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请输入年终奖金额!' }],
                  initialValue: dataItem.price,
                })(<Input placeholder="年终奖金额" addonAfter="元" type="number" disabled />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="年终奖说明" labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}>
                {getFieldDecorator('reason', {
                  initialValue: dataItem.reason,
                })(
                  <Input.TextArea
                    placeholder="备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="年终奖附件" {...ItemLayout}>
                {getFieldDecorator('files', {
                  rules: [{ required: true, message: '请上传年终奖附件' }],
                  initialValue: dataItem.files || [],
                })(
                  <UploadFile
                    type="ghost"
                    fileList={dataItem.file}
                    isPreview
                    onRemove={this.fileRemove}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/hr/bonus/FormBase.js